/* eslint-disable no-param-reassign */
import WallspiceWebgl from 'Renderer/WallspiceWebgl'
import RenderItem from 'Renderer/RenderItem'
// import WallspiceWebgl, { ShadowDirectionURLs } from 'Renderer/WallspiceWebgl'
import * as THREE from 'three'

import * as artTypes from 'constants/artTypes'
// import { INSPECT_MAX_BYTES } from 'buffer';

let maxArtItemOffset = 0.1 // eslint-disable-line

class ArtItem extends RenderItem {
    constructor(id, renderer, position, onUpdate, artImage, frameData, size) {
        super(id, renderer, position, false, onUpdate)

        this.renderer = renderer
        this.size = size
        this.frameData = frameData
        this.selected = false
        this.frameCorners = null
        this.rotation = null
        this.zoffset = maxArtItemOffset
        maxArtItemOffset += 0.1

        this.outerL = 0
        this.outerR = 0
        this.outerB = 0
        this.outerT = 0

        this.ratio = parseFloat((artImage.width / artImage.height).toFixed(2), 10)
        if (artImage.width >= artImage.height) {
            this.orientation = artTypes.ART_LANDSCAPE
        } else {
            this.orientation = artTypes.ART_PORTRAIT
        }
        this.artMaterial = WallspiceWebgl.createArtMaterial(artImage)

        this.artSize = [(this.size * this.ratio), this.size]

        this.loadFrame()
        this.planeIndex = null
        this.shadowDirection = null
        this.shadowMaterial = null
        this.shadowPlane = null

        this.isUnderMouse = false
    }

    // applyCubemap() {
    //     // eslint-disable-next-line func-names
    //     setTimeout(function(){ this.attemptCubemap() }.bind(this), 5000)
    // }

    // attemptCubemap() {
    //     const cubeTex = this.renderer && this.renderer.cubeTex
    //     const model = this.getObject()
    //     if(cubeTex && model) {
    //         if(model) {
    //             model.traverse((child) => {
    //                 if (child instanceof THREE.Mesh) {
    //                     cubeTex.then((cubetexmap) => {
    //                         const envMapIntensity = 1.0
    //                         child.material.envMapIntensity = envMapIntensity
    //                         child.material.originalEnvMapIntensity = envMapIntensity
    //                         child.material.envMap = cubetexmap
    //                         child.material.envMap.isCubeTexture = true
    //                         child.material.needsUpdate = true
    //                         this.update()
    //                     })
    //                 }
    //             })
    //         }
    //     } else {
    //         // eslint-disable-next-line func-names
    //         setTimeout(function(){ this.attemptCubemap() }.bind(this), 250)
    //     }
    // }


    applyCubemapMat(material) {
        setTimeout(() => { this.attemptCubemapMat(material) }, 50)
    }

    attemptCubemapMat(material) {
        const cubeTex = this.renderer && this.renderer.cubeTex
        const model = this.getObject()
        if(cubeTex && model) {
            cubeTex.then((cubetexmap) => {
                const envMapIntensity = 1.0
                material.envMapIntensity = envMapIntensity
                material.originalEnvMapIntensity = envMapIntensity
                material.envMap = cubetexmap
                material.envMap.isCubeTexture = true
                material.needsUpdate = true
                this.update()
            })
        } else {
            setTimeout(() => { this.attemptCubemapMat() }, 250)
        }
    }

    getCorners() {
        return this.frameCorners
    }

    getRotation() {
        return this.rotation
    }

    getOrientation() {
        return this.orientation
    }

    getZoffset() {
        return this.zoffset || maxArtItemOffset
    }

    updateFrame(frameData, size) {
        this.frameData = frameData
        this.setSizeNoReload(size)
        this.loadFrame()
    }

    setSizeNoReload(size) {
        this.size = size
        this.artSize = [(size * this.ratio), size]
    }

    setPosition(xy) {
        const isValid = super.setPosition(xy)

        if (isValid) {
            const pose = this.getPose()
            const zOffset = this.getZoffset()
            pose.pos[0] += pose.rot[2][0] * 0.001 * zOffset
            pose.pos[1] += pose.rot[2][1] * 0.001 * zOffset
            pose.pos[2] += pose.rot[2][2] * 0.001 * zOffset
        }

        this.update()
        return isValid
    }

    setVisible(shouldBeVisible) {
        super.setVisible(shouldBeVisible)
        this.update()
    }

    setSelected(shouldBeSelected) {
        this.selected = shouldBeSelected
        if (this.selected) {
            this.enableOutline()
        } else {
            this.disableOutline()
        }
        this.updateOutlineThickness()
        this.update()
    }

    onHover() {
        this.isUnderMouse = true
        this.enableOutline()
        this.updateOutlineThickness()
    }

    onHoverEnd() {
        this.isUnderMouse = false
        if (!this.selected) {
            this.disableOutline()
        }
        this.updateOutlineThickness()
    }

    onDragStart() {
        super.onDragStart()

        // Exchange the current z-offset with the highest artItem
        if (this.getZoffset() < maxArtItemOffset) {
            const maxItem = Array.from(this.Renderer.renderItems.values()).filter(item => item instanceof ArtItem)
                .reduce((max, cur) => cur.zoffset > max.zoffset ? cur : max, { zoffset: 0 })
            const temp = maxItem.zoffset
            maxItem.zoffset = this.zoffset
            this.zoffset = temp
            maxItem.setPosition(maxItem.position)
        }
    }

    updateOutlineThickness() {
        if (!this.Renderer) {
            return
        }
        // assuming here that hover+selcted can happen only when a single object is outlined,
        // muliple objects can't be selcted and hovered over at the same time
        this.Renderer.setThickOutline(this.isUnderMouse && this.selected)
    }

    update(metrics = null) {
        if (!this.getObject()) {
            return
        }

        const { Renderer } = this

        const pose = this.getPose()
        if (!pose) {
            // need to call react's update to assign metrics to render item, it is used to track 
            // if item is still loading
            const oneTimeRenderCallback = metrics ?
                () => this.onUpdate({ corners: null, metrics }) :
                null
            Renderer.onChildUpdate(oneTimeRenderCallback)
            return
        }

        const rotation = pose.rot
        const position = pose.pos

        const mat4 = new THREE.Matrix4();
        WallspiceWebgl.createMat4(rotation, position, mat4)
        this.getObject().matrix.copy(mat4)

        const corners = WallspiceWebgl.projBoundBox(mat4, this.bbox, this.Renderer.camera.projectionMatrix)
        this.rotation = pose.rot
        this.frameCorners = corners

        if (this.planeIndex !== pose.planeIndex) {
            this.planeIndex = pose.planeIndex
        }
        // must reapply uniform settings as material might have been recreated
        // due to dynamic frame edits
        const lightDirection = Renderer.getLightDirectionByIndex(this.planeIndex)
        const cast = WallspiceWebgl.cardinalToVector(lightDirection)
        WallspiceWebgl.setShadowMeshDirection(this.shadowMesh, cast);

        const oneTimeRenderCallback = metrics ?
            () => this.onUpdate({ corners, metrics }) :
            null
        Renderer.onChildUpdate(oneTimeRenderCallback)
        if (!metrics) {
            this.onUpdate({ corners })
        }
    }

    async loadFrame() {
        this.metrics.msStartLoad = Date.now()

        if (this.getObject()) {
            this.removeFromScene()
            this.unsetObject()
        }

        const frame = this.makeFrameModel()
        frame.name = this.name
        frame.matrixAutoUpdate = false
        frame.visible = this.visible
        frame.castShadow = true
        frame.receiveShadow = false

        this.setObject(frame)
        // this.visualizeDebugBoundBox(0x00FF00)
        this.addToScene()

        this.metrics.msEndLoad = Date.now()
        this.metrics.sLoadTime = (this.metrics.msEndLoad - this.metrics.msStartLoad) * 0.001

        if (this.selected) {
            this.setSelected(true)
        }
        this.update(this.metrics)
    }

    makeFrameModel() {
        const frame = new THREE.Object3D()
        const width = this.artSize[0];
        const height = this.artSize[1];
        let innerDepth = this.frameData.canvasDepth;
        let maxDepth = 0;
        let innerLength = 0.02;
        const outerLength = 0.04;
        this.outerL = -width * 0.5;
        this.outerR = width * 0.5;
        this.outerB = -height * 0.5;
        this.outerT = height * 0.5;

        // canvas
        const geometryCanvas = WallspiceWebgl.makeCanvasGeometry(width, height, this.frameData.canvasDepth, false);
        const canvas = new THREE.Mesh(geometryCanvas, this.artMaterial)
        canvas.name = 'canvas'
        frame.add(canvas)
        this.bbox.setFromObject(frame)
        this.applyCubemapMat(this.artMaterial)

        if (this.frameData.matte && this.frameData.matte.sections) {
            const matDesc = this.frameData.matte.sections
            let mOff = 0
            if (this.frameData.matOffset) {
                mOff = this.frameData.matOffset
            }

            for (let i = 0; i < matDesc.length; i += 1) {
                const tmp = matDesc[0].profile[matDesc[i].profile.length - 1][1] + mOff
                if (tmp > innerDepth) {
                    innerDepth = tmp
                }
                const L = this.outerL
                const R = this.outerR
                const B = this.outerB
                const T = this.outerT
                WallspiceWebgl.createFrameMaterial(matDesc[i].textureName,
                    matDesc[i].albedo).then((material) => {
                        this.applyCubemapMat(material)
                    const geometry = WallspiceWebgl.extrudeFrame(L, R, B, T, mOff,
                        matDesc[i].scaleU, matDesc[i].scaleV, matDesc[i].profile)
                    const segment = new THREE.Mesh(geometry, material)
                    segment.name = `matSegment_${i}`
                    frame.add(segment)
                    this.update()
                })
                const extrusionDist = matDesc[i].profile[matDesc[i].profile.length - 1][0]
                this.outerL -= extrusionDist
                this.outerR += extrusionDist
                this.outerB -= extrusionDist
                this.outerT += extrusionDist
            }
        }
        const iL = this.outerL
        const iR = this.outerR
        const iB = this.outerB
        const iT = this.outerT
        if (this.frameData.sections) {
            const frDesc = this.frameData.sections;
            for (let i = 0; i < frDesc.length; i += 1) {
                let textureName = frDesc[i].textureName
                let albedo = frDesc[i].albedo
                if (this.frameData.color) {
                    if (this.frameData.color.material) {
                        textureName = this.frameData.color.material
                        albedo = '#ffffff'
                    }
                    if (this.frameData.color.albedo) {
                        albedo = this.frameData.color.albedo
                    }
                }
                for (let j = 0; j < frDesc[i].profile.length; j += 1) {
                    if (frDesc[i].profile[j][1] > maxDepth) {
                        maxDepth = frDesc[i].profile[j][1]
                    }
                }

                const L = this.outerL
                const R = this.outerR
                const B = this.outerB
                const T = this.outerT
                WallspiceWebgl.createFrameMaterial(textureName, albedo).then((material) => {
                    this.applyCubemapMat(material)
                    const geometry = WallspiceWebgl.extrudeFrame(L, R, B, T, 0,
                        frDesc[i].scaleU, frDesc[i].scaleV, frDesc[i].profile)
                    const segment = new THREE.Mesh(geometry, material)
                    segment.name = `frameSegment_${i}`
                    frame.add(segment)
                    this.update()
                })
                const extrusionDist = frDesc[i].profile[frDesc[i].profile.length - 1][0]
                this.outerL -= extrusionDist
                this.outerR += extrusionDist
                this.outerB -= extrusionDist
                this.outerT += extrusionDist
            }
        } else {
            innerDepth = 0;
            innerLength = 0;
        }

        this.bbox.min.x = this.outerL
        this.bbox.max.x = this.outerR
        this.bbox.min.y = this.outerB
        this.bbox.max.y = this.outerT
        if (this.bbox.max.z < maxDepth) {
            this.bbox.max.z = maxDepth
        }

        this.shadowMesh = WallspiceWebgl.makeFrameShadow(this.outerL, this.outerR, this.outerB, this.outerT,
            iL, iR, iB, iT, innerDepth, innerLength, outerLength)

        this.shadowMesh.name = 'frameShadow'
        frame.add(this.shadowMesh)

        return frame
    }
}

export default ArtItem
